// extracted by mini-css-extract-plugin
var _1 = "ttICwfys7nfIxE0bT2pk";
export { _1 as "verticalCenter" }
